import clsx from "clsx";
import { useState } from "react";
import { Outlet } from "react-router";
import { Link } from "react-router-dom";

import { ReactComponent as ChevronLeftCircleIcon } from "assets/icons/chevron-left-circle.svg";

const Layout = ({
  title,
  nav,
}: {
  title: string;
  nav: {
    label: string;
    links: {
      path: string;
      label: string;
      count?: number;
      isActive?: boolean;
    }[];
  }[];
}) => {
  const [isOpen, setIsOpen] = useState(true);

  const toggleLeft = () => {
    setIsOpen((b) => !b);
  };

  return (
    <div
      className={clsx("relative flex h-full duration-300", {
        "-ml-[12rem] 1350:-ml-[13.75rem]": !isOpen,
      })}
    >
      <div className="absolute h-full w-[12rem] 1350:w-[13.75rem] flex flex-col border-r border-gray duration-300">
        <div className="sticky top-14 flex flex-col h-[calc(100vh-3.5rem)]">
          <div className="flex justify-between pt-[1.875rem] pl-[1.25rem] pr-[0.625rem] pb-[4.313rem] bg-lightGray">
            <h3 className="text-16 font-medium">{title}</h3>
            <button
              type="button"
              onClick={toggleLeft}
              className={clsx({ "translate-x-[200%] rotate-180": !isOpen })}
            >
              <ChevronLeftCircleIcon className="size-6" />
            </button>
          </div>
          <div className="bg-white flex-1 py-[0.938rem] px-[0.625rem] space-y-[0.625rem] text-14">
            {nav.map((item) => (
              <div
                key={item.label}
                className="rounded-md border border-secondary overflow-hidden"
              >
                <h4 className="font-medium text-center py-[0.625rem]">
                  {item.label}
                </h4>
                <ul>
                  {item.links.map((link) => (
                    <li key={link.path}>
                      <Link
                        to={link.path}
                        className={clsx(
                          "relative border-t border-secondary flex px-[0.625rem] py-[0.563rem] duration-150 hover:bg-[#F1F7FF]",
                          { "bg-[#F1F7FF]": link.isActive },
                        )}
                      >
                        <span>{link.label}</span>
                        {!!link.count && (
                          <span className="absolute top-0 right-[0.625rem] bottom-0 my-auto bg-[#FFC7C7] rounded-md h-7 w-[2.688rem] inline-flex justify-center items-center">
                            {link.count}
                          </span>
                        )}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Outlet />
    </div>
  );
};

export default Layout;
